
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"200","height":"200","viewBox":"0 0 52.917 52.917","xmlns":"http://www.w3.org/2000/svg","stroke":"#000","fill":"none","stroke-width":"5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.288 41.01l13.758-14.552-13.758-14.552"}})])
          )
        }
      }
    